import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { IconComponent } from '../../../../../shared/components/icon/icon.component';
import { MenuItem } from '../../../../../shared/components/menu/models/menu';

@Component({
  selector: 'l-content-pdf',
  standalone: true,
  host: { style: 'display: block; height: 100%;' },
  imports: [CommonModule, PdfViewerModule, IconComponent],
  templateUrl: './content-pdf.component.html',
})
export class ContentPdfComponent {

  //#region Public Properties

  @Input()
  public fileUrl: string = '';

  public zoomLevel: number = 1;

  public isMenuOpen: boolean = false;

  public readonly menuItems: MenuItem[] = [
    {
      icon: 'download',
      title: 'Baixar PDF',
      action: () => this.downloadPdf(),
    },
    {
      icon: 'link_2',
      title: 'Referências',
      action: () => this.openReferences(),
    },
    {
      icon: 'music_cast',
      title: 'Playlist',
      action: () => this.openPlaylist(),
    },
  ];

  //#endregion

  //#region Getters

  public get sanitizedFileUrl(): string {
    const rawUrl = (this.fileUrl || '').trim();

    if (!rawUrl)
      return '';

    const withoutQuotes = this.removeEdgeQuotes(rawUrl);
    return encodeURI(withoutQuotes);
  }

  //#endregion

  //#region Public Methods

  public toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  public zoomIn(): void {
    this.zoomLevel = Math.min(3, Number((this.zoomLevel + 0.2).toFixed(2)));
  }

  public zoomOut(): void {
    this.zoomLevel = Math.max(0.5, Number((this.zoomLevel - 0.2).toFixed(2)));
  }

  public downloadPdf(): void {
    if (!this.sanitizedFileUrl)
      return;

    window.open(this.sanitizedFileUrl, '_blank', 'noopener,noreferrer');
  }

  public openReferences(): void {
    // Implement the logic to open references
  }

  public openPlaylist(): void {
    // Implement the logic to open playlist
  }

  //#endregion

  //#region Private Methods

  private removeEdgeQuotes(value: string): string {
    const quoteChars = new Set(['\'', '"', '`']);
    let start = 0;
    let end = value.length;

    while (start < end && quoteChars.has(value[start])) {
      start++;
    }

    while (end > start && quoteChars.has(value[end - 1])) {
      end--;
    }

    return value.slice(start, end);
  }

  //#endregion

}
